import { getItem, queryTable } from "./helper/DynamoDBHelper";

export async function getOenInfo({ oen, setError }) {
  try {
    const result = await getItem({ oen });
    if (!result) {
      throw new Error(`No Matching UUID for OEN`);
    }
    return result;
  } catch (e) {
    setError(e.message);
  }
}


export async function getUUIDInfo({ uuidValue, setFileDetails, setError }) {
  try {
    const result = await queryTable({ uuidValue });
    if (!result) {
      throw new Error(`No Matching UUID found`);
    }
    setFileDetails(result);
    return result;
  } catch (e) {
    setError(e.message);
  }
}
